export default __webpack_public_path__ + "static/Economic Model Whitepaper - Japanese-b79e9380f28789943217dfc5671e8480.pdf";